export default __webpack_public_path__ + "static/media/solr-sup-book.0ffda59a.png";